{
  "name": "transport-order-exchange-web",
  "description": "The web Frontend of the transport-order-exchange context.",
  "private": true,
  "version": "0.1.0",
  "type": "module",
  "scripts": {
    "start": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "test:ci": "vitest run --reporter=junit --outputFile.junit=./results/junit.xml",
    "test-dev": "vitest",
    "coverage": "vitest run --coverage",
    "license-check": "license-checker --production --json --onlyAllow \"`cat whitelist.txt`\" --excludePackages \"transport-order-exchange-web@0.1.0\" --out licenses.txt",
    "lint": "biome check src",
    "lint-fix": "npm run lint -- --write",
    "format-code": "biome format --write ./src",
    "audit": "npm audit --registry https://registry.npmjs.org --audit-level moderate --parseable --omit dev",
    "pull-translations": "phrase pull --access_token $PHRASEAPP_ACCESS_TOKEN && npm run merge-translations",
    "merge-translations": "nodenv ./mergeTranslations.js",
    "cypress-open": "cypress open",
    "cypress-run": "cypress run",
    "cypress-ci": "start-server-and-test start http://localhost:3000 cypress-run",
    "ci-playwright": "npx playwright install --with-deps && npm run test-integration",
    "test-integration": "npx playwright test",
    "test-integration-open": "npx playwright test --ui",
    "test-integration-create": "npx playwright codegen",
    "show-report": "npx playwright show-report results/playwright"
  },
  "dependencies": {
    "@reduxjs/toolkit": "2.12.0",
    "@rio-cloud/rio-notifications-component": "1.0.0",
    "@rio-cloud/rio-session-expired-info": "2.0.0",
    "@rio-cloud/rio-uikit": "2.4.1",
    "@rio-cloud/rio-user-menu-component": "4.0.0",
    "@sentry/browser": "10.71.0",
    "date-fns": "4.1.0",
    "events": "3.3.0",
    "fp-ts": "2.16.11",
    "iframe-resizer-react": "1.1.0",
    "io-ts": "2.2.22",
    "lodash": "4.18.1",
    "moment": "2.30.1",
    "oidc-client-ts": "3.5.0",
    "qs": "6.16.0",
    "react": "18.3.1",
    "react-dom": "18.3.1",
    "react-hook-form": "7.72.1",
    "react-intl": "6.8.9",
    "react-redux": "9.2.0",
    "react-router": "7.18.2",
    "react-router-dom": "7.18.2",
    "redux": "5.0.1",
    "uuid": "14.0.2"
  },
  "devDependencies": {
    "@biomejs/biome": "2.5.10",
    "@playwright/test": "1.57.0",
    "@redux-devtools/extension": "3.3.0",
    "@testing-library/dom": "10.4.1",
    "@testing-library/jest-dom": "6.9.1",
    "@testing-library/react": "16.3.2",
    "@testing-library/user-event": "14.6.6",
    "@types/lodash": "4.17.25",
    "@types/node": "24.13.3",
    "@types/qs": "6.15.1",
    "@types/react": "18.3.5",
    "@types/react-dom": "18.3.0",
    "@types/react-redux": "7.1.34",
    "@types/uuid": "10.0.0",
    "@vitejs/plugin-react": "5.2.0",
    "@vitest/coverage-v8": "4.1.11",
    "cypress": "14.5.4",
    "jsdom": "26.1.0",
    "license-checker": "25.0.1",
    "lint-staged": "16.4.0",
    "msw": "2.13.0",
    "playwright": "1.57.0",
    "pre-commit": "1.2.2",
    "rollup-plugin-visualizer": "7.0.1",
    "start-server-and-test": "2.1.3",
    "typescript": "5.9.3",
    "vite": "8.0.16",
    "vite-plugin-svgr": "4.5.0",
    "vitest": "4.1.11",
    "vitest-fetch-mock": "0.3.0"
  },
  "browserslist": [
    "last 2 versions",
    "last 5 Chrome versions",
    "Firefox >= 90",
    "Edge >= 95",
    "Safari >= 14"
  ],
  "pre-commit": [
    "format-code"
  ],
  "overrides": {
    "js-yaml": "4.1.1",
    "cross-spawn": "7.0.6",
    "tmp": "0.2.7",
    "@rio-cloud/rio-uikit": {
      "lodash": "4.18.1"
    }
  },
  "msw": {
    "workerDirectory": [
      ""
    ]
  }
}
